import { render, staticRenderFns } from "./Comparate.vue?vue&type=template&id=1774df48&"
import script from "./Comparate.vue?vue&type=script&lang=js&"
export * from "./Comparate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports